import { gql } from 'apollo-angular';
import { dispositionFields } from 'src/app/deals/deal-dispositions/graphql/dispositions';

const GET_DISPOSITIONS = gql`
  query getDispositions($isClosed: Boolean!) {
    getPipelineMilestones(
      forMilestone: ["Closed", "Disposition Committee"]
      onPipeline: "Disposition"
    ) {
      id
      milestone {
        id
        name
      }
    }
    statusesBySequence(sequence_name: "Disposition") {
      id
      name
    }
    dispositionProceedTypes {
      id
      name
    }
    dateTypes(model: "dispositions") {
      id
      name
    }
    dispositionTypes {
      id
      name
    }
    getAllDispositions(isClosed: $isClosed) {
      ...DispositionFields
      project {
        id
        name
        participants(withRole: ["Asset Manager", "Originator", "Developer", "Sponsor"]) {
          id
          role {
            id
            name
          }
          organization {
            id
            name
          }
          person {
            id
            name
          }
          sponsor {
            id
            name
            nickname
          }
        }
        projectCredits {
          id
          projectCreditOutlets {
            id
            fund {
              id
              name
            }
            certificatedOutlet {
              id
              organization {
                id
                name
              }
            }
          }
        }
        projectDetail {
          id
          fully_disposed
          risk_rating
        }
        properties {
          id
          total_units
          entity {
            entityAddresses {
              address {
                zipCode {
                  city
                  state {
                    name
                    abbreviation
                  }
                }
              }
            }
          }
        }
        dispositionDetail {
          id
          disposition_notes
        }
        dealTerm {
          id
          year_15_end
        }
      }
    }
  }
  ${dispositionFields}
`;

export { GET_DISPOSITIONS };
